"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileUpload = void 0;
const ipfs_service_1 = require("@app/services/ipfs.service");
const react_1 = require("react");
const useFileUpload = () => (0, react_1.useCallback)((file) => __awaiter(void 0, void 0, void 0, function* () { return new ipfs_service_1.IPFSService().uploadFileToIpfs(file); }), []);
exports.useFileUpload = useFileUpload;
